import axios from 'axios'

import { getLoketBridgeApiUrl } from '../index'

export const getLoketInfo = () => axios.get(`${getLoketBridgeApiUrl()}/info`)
